export default {
      id: "whatsapp-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "sprite.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }